import { Injectable } from '@angular/core';

import { DataService } from '../../shared/services/data.service';
import { ObservationConstantsService } from '../services/observation-constants.service';
import { ConstantsService } from '../../shared/services/constants.service';
import { MasterscreenConstantsService } from '../../masterscreen/services/masterscreen-constants.service';
import { BaseService } from '../../shared/services/base.service';
@Injectable()
export class ObservationService {
  public updatedObservationData: any;
  public oldActionData: any;
  public currentObservationPageIndex: number;
  public currentObservationRequestId: string;

  constructor(private dataService: DataService, private baseService: BaseService) {
  }
  public static RedirectUrls = {
    ObservationOverview: '/observation/observation-card-overview'
  };

   

  public setAllObservationIds(allObservationIds) {
    let OBSIds = [];
    allObservationIds.forEach(item => {
      OBSIds.push({ 'ObservationId': item.ObservationId, 'UnitId': item.UnitId });
    });
    this.baseService.setItemInSession('observationIds', JSON.stringify(OBSIds));
  }
  public getAllObservationIds() {
   
    return JSON.parse(this.baseService.getItemFromSession('observationIds'));
  }
  public setUpdatedObservationData(data) {
    this.updatedObservationData = data;
  }
  public getUpdatedObservationData() {
    return this.updatedObservationData;
  }
  //BOC Pritesh
  public setoldActionData(data) {
    this.oldActionData = data;
  }
  public getoldActionData() {
    return this.oldActionData;
  }
  //EOC Pritesh

  public setcurrentObservationRequestId(obsId) {
    this.currentObservationRequestId = obsId;
  }
  public getcurrentObservationRequestId() {
    return this.currentObservationRequestId;
  }

  public setcurrentObservationPageIndex(pageId) {
    this.currentObservationPageIndex = pageId;
  }
  public getcurrentObservationPageIndex() {
    return this.currentObservationPageIndex;
  }
  public observationRequestId = 0;
  /**
     * Function to post detalis
     * @param Model - Model to send data to api
     * @param callbackMethod - return the response
     */
  // service call to insert observation data
  submitObservationData(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.InsertObservationData, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  updateObservationData(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.UpdateObservationData, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  // Method to post action details to insert into database.
  insertActionDetails(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.InsertActonDetails, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Method to inactive action details in database.
  cancelactiondetails(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.Cancelactiondetails, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Method to inactive action details in database.
  deleteactiondetails(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.Deleteactiondetails, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // service call to get location
  getLocationData(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetLocationDetails, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // service call to get Company
  getCompanyData(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetCompanyDetails, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // service call to get all the employee's and contractor's name whose initial entered
  getSearchResultsForUsers(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetUsersOnSearch, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get Observation request for dashboard
  getObservationRequestsForDashboard(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetObservationRequestsForDashboard, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get Status
  getStatusByProcessId(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetStatusByProcessId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get Process
  getProcess(callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetProcess)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  getUserTypes(callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetUserTypes)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get Observation data of particular id
  getObservationRequest(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetObservationRequest, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  saveUserLogInDetails(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.UserLogInDetails, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  getUserDetails(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.GetUserByEmailOrId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Cancel Observation request
  cancelObservationRequest(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.CancelObservationRequest, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // restate observation request
  ReStateObservationrequest(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.ReStateObservationrequest, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // close Observation request
  closeObservationRequest(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.CloseObservationRequest, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Acknowledge Observation request
  acknowledgeObservationRequest(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.AcknowledgeObservationRequest, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // get selected Id
  getSelectedObservationRequestId(Id) {
    this.observationRequestId = Id;
  }

  // send observation request Id
  sendObservationRequestId() {
    return this.observationRequestId;
  }

  // Get Observation data HSE Advisor
  getObservationRequestForHSEAdvisor(model, callbackMethod) {
     
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetObservationRequestForHSEAdvisor, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get Observation data HSE Advisor
  exportToExcelObservationRequestForHSEAdvisor(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.ExportToExcelObservationRequestForHSEAdvisor, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get Observation data for particular id for HSE Advisor
  getObservationForHSEAdvisor(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetObservationForHSEAdvisor, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // delete onservation by HSE Advisor
  deleteObservationByHSEAdvisor(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.DeleteObservationByHSEAdvisor, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
* Function to Get Observation type Details by company id.
* @param model - Model contain api request
* @param response - response of request.
*/
  getObservationTypeByCompanyId(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetObservationTypeByCompanyId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // get hazard by company id
  getHazardTypeByCompanyId(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetHazardTypeByCompanyId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get Observation data By Observation Id
  getObservationRequestByObservationId(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetObservationRequestByObservationId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // get action by observation id
  getActionsByObservationId(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetActionsByObservationId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get Temp observation requests for file upload by mobile user
  GetTempObservationRequestForBackOffice(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetTempObservationRequestForBackOffice, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
* Function to Get User Details By Temp Observation ID.
* @param model - Model contain api request
* @param response - response of request.
*/
  GetUserDetailsByTempObservationId(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetUserDetailsByTempObservationId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
* Function to Delete Temp Observation Request if image are blur/Empty.
* @param model - Model contain api request
* @param response - response of request.
*/
  deleteObservationRequestByTempObsId(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.DeleteObservationRequestByTempObsId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
* Function to submit request and update status as submitted by temp observation id.
* @param model - Model contain api request
* @param response - response of request.
*/
  UpdateTempObservationRequestForBackOffice(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.UpdateTempObservationRequestForBackOffice, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
* Function to Get observation status report.
* @param model - Model contain api request
* @param response - response of request.
*/
  GetObservationStatusReport(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetObservationStatusReport, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // get action by observation id
  getAllActionByObservationId(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.GetAllActionByObservationId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  // get action by observation id
  exportToExcel(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.ExportToExcel, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
* Function to Get Observation category Details.
* @param model - Model contain api request
* @param response - response of request.
*/
  getObservationCategoryDetails(model, callbackMethod) {
    this.dataService.post(MasterscreenConstantsService.APIURL.getObservationCategoryDetails, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  updateHazardType(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.UpdateHazardType, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
* Function to insert action details for action from hse advisor and change the status as knowledge
* @param model - Model contain api request
* @param response - response of request.
*/
  insertActionAssignedByHseAdvisor(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.InsertActionAssignedByHseAdvisor, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
   * Function to insert action details for action from hse advisor and change the status as knowledge
   * @param model - Model contain api request
   * @param response - response of request.
   */
  updateActionAssignedByHseAdvisor(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.UpdateActionAssignedByHseAdvisor, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
* Function to get route name based on role(case owner)
* @param routesFlag - array of route
* @param route - return the route
*/
  checkRouteForBackOffice(routesFlag: any) {
    const loggedInUserJson = JSON.parse(this.baseService.getItemFromSession(ConstantsService.commonConstants.loggedInUser));
    if (loggedInUserJson.UserRoles.length >= 0) {
      const roles = loggedInUserJson.UserRoles.find((item) => item.RoleName === ConstantsService.Roles.BackOffice);
      if (roles !== undefined && roles.RoleName === ConstantsService.Roles.BackOffice) {
        return routesFlag;
      } else {
        // Write logic to remove the route of case owner
        for (let index = 0; index < routesFlag.length; index++) {
          if (routesFlag[index].routeName === ObservationConstantsService.RouteName.BackofficeDashboard) {
            routesFlag.splice(index, 1);
          }
        }
        return routesFlag;
      }
    }
  }
  /**
    * Function to Download PDF
    * @param model - Model contain ProcessId and SourceId
    * @param callbackMethod - return the response
    */
  downloadPDF(model, callbackMethod) {
    this.dataService.postHttpResponse(ObservationConstantsService.ObservationCardURL.DownloadPDF, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  savePDF(model, callbackMethod) {
    this.dataService.postHttpResponse(ObservationConstantsService.ObservationCardURL.SavePDF, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  submitSpecificationData(model, callbackMethod) {
    this.dataService.post(ObservationConstantsService.ObservationCardURL.SubmitSpecificationData, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  downloadZIP(model, callbackMethod) {
    this.dataService.postHttpResponse(ObservationConstantsService.ObservationCardURL.DownloadZIP, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
}
